import type { Messages } from './messages';

/**
 * Copy for `src/app/tenants/`. Owned by that page's author, and by nobody else.
 *
 * Every key starts with `tenants.` — the compiler refuses anything else, so
 * this file cannot collide with another page's. Shared words (save, cancel,
 * retry, statuses, role names) are already in `common.ts` and
 * `vocabulary.ts`; use those rather than restating them here.
 */
export const tenants = {
  'tenants.title': 'المنشآت',
  'tenants.subtitle': 'كل منشأة على المنصّة: حالتها، حساباتها، وإنفاقها هذا الشهر. افتح منشأة من اسمها.',
  'tenants.create': 'منشأة جديدة',

  /* Summary strip — GET /overview */
  'tenants.summary': 'ملخّص المنشآت',
  'tenants.statTenants': 'المنشآت',
  'tenants.statTenantsSub': 'مفعّلة: {active} · موقوفة: {suspended}',
  'tenants.statAccounts': 'الحسابات في كل المنشآت',
  'tenants.statAccountsSub': 'نشطة: {active} · غير نشطة: {inactive}',
  'tenants.statOperators': 'مشغّلو المنصّة',
  'tenants.statOperatorsSub': 'نشطون: {active}',
  'tenants.summaryFailed': 'تعذّر تحميل الملخّص: {message}',

  /* Filters */
  'tenants.search': 'ابحث في المنشآت',
  'tenants.searchPlaceholder': 'الاسم أو المعرّف',
  'tenants.statusFilter': 'الحالة',
  'tenants.statusAll': 'الكل',
  'tenants.verticalFilter': 'القطاع',
  'tenants.verticalAll': 'كل القطاعات',
  'tenants.sort': 'الترتيب',
  'tenants.sortCreated': 'الأحدث إنشاءً',
  'tenants.sortName': 'الاسم (أ–ي)',
  'tenants.sortSpend': 'الأعلى إنفاقًا هذا الشهر',

  /* Table */
  'tenants.table': 'قائمة المنشآت',
  'tenants.colTenant': 'المنشأة',
  'tenants.colVertical': 'القطاع',
  'tenants.colStatus': 'الحالة',
  'tenants.colAccounts': 'الحسابات',
  'tenants.colConversations': 'المحادثات',
  'tenants.colSpend': 'الإنفاق هذا الشهر',
  'tenants.colLastActivity': 'آخر نشاط',
  'tenants.colAttention': 'تنبيهات',
  'tenants.colCreated': 'أُنشئت',
  'tenants.accounts': '{active} من {total}',
  'tenants.accountsSub': 'نشطة',
  'tenants.spendLabel': 'إنفاق {name} هذا الشهر',
  /** A colon, not a counted noun: Arabic agreement changes between 1, 2 and 3–10, and the count is 1–4. */
  'tenants.attention': 'تنبيهات: {count}',
  'tenants.attentionTitle': 'افتح نظرة {name} العامة لمعرفة ما يحتاج انتباهًا',
  'tenants.attentionNone': 'لا شيء',
  'tenants.lastActivityNone': 'لا نشاط بعد',
  'tenants.rowActions': 'إجراءات {name}',
  'tenants.actionOpen': 'فتح المنشأة',
  'tenants.actionMembers': 'الأعضاء',
  'tenants.actionMail': 'إعدادات البريد',

  /* States */
  'tenants.firstRunTitle': 'لا منشآت على المنصّة بعد',
  'tenants.firstRunBody':
    'أنشئ أول منشأة: الاسم والمعرّف والقطاع، ثم المشرف العام الأول الذي يصله رابط دعوة ليختار كلمة مروره بنفسه.',
  'tenants.firstRunNoCreate': 'رتبتك لا تسمح بإنشاء منشأة. اطلب ذلك من مشغّل يملك صلاحية إنشاء المنشآت.',
  'tenants.noMatchTitle': 'لا منشآت تطابق هذه التصفية',
  'tenants.noMatchBody': 'جرّب جزءًا من الاسم أو المعرّف، أو امسح التصفية لعرض كل المنشآت.',
  'tenants.staleList': 'تعذّر تحديث القائمة، والمعروض هو آخر نتيجة وصلت: {message}',
} as const satisfies Messages<'tenants'>;
